var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGiftFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.173 7.5v7.485H0V7.472h4.017a4.498 4.498 0 0 1-1.098-2.95A4.531 4.531 0 0 1 7.453 0h.741c1.558 0 2.933.786 3.75 1.98A4.534 4.534 0 0 1 15.694 0h.714a4.531 4.531 0 0 1 4.534 4.523 4.498 4.498 0 0 1-1.098 2.95H24v7.512H12.738V7.472h4.278A3.01 3.01 0 0 0 19.42 4.53a3.01 3.01 0 0 0-3.012-3.004h-.715a3.013 3.013 0 0 0-2.983 2.591c.012.134.018.27.018.407V7.5h-1.555Zm-4.295-.028h4.281v-2.95c0-.138.007-.275.019-.41A3.013 3.013 0 0 0 8.194 1.52h-.741A3.01 3.01 0 0 0 4.44 4.523a3.01 3.01 0 0 0 2.437 2.95Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.173 16.487H0V24h11.173v-7.513ZM12.738 16.487H24V24H12.738v-7.513Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGiftFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/GiftFilled.25d761c6ad7a6a901a40ba650d8d03d5.svg";